import { useEffect } from "react"
import { garconClient } from "@apis/axiosClients"
import { useAuth0 } from "@auth0/auth0-react"

// We need to check if the error is a string because we have things like this with a 401 code:
// {
//   "type": "BadLogin",
//   "error": "Error: Status code 429 with message {\"error\"=>\"access_denied\", \"error_description\"=>\"Too Many Requests\", \"error_uri\"=>\"https://auth0.com/docs/policies/rate-limits\"}"
// }
// So since that's an object, doing .toLowerCase will throw the error error.response?.data?.toLowerCase is not a function.

export const useUnauthorizedInterceptor = () => {
  const { logout } = useAuth0()

  useEffect(() => {
    const resInterceptor = garconClient.interceptors.response.use(
      function onFulfilled(response) {
        return response
      },
      function onRejected(error) {
        if (
          import.meta.env.VITE_DISABLE_UNAUTHED_LOGOUT !== "true" &&
          error.response?.status === 401 &&
          // We need to check if the error is a string. See comment above for more details.
          typeof error.response?.data === "string" &&
          error.response?.data?.toLowerCase() === "signature has expired"
        ) {
          // Save current location to use it later in onRedirectCallback
          const logOutUrl = window.location.pathname + window.location.search
          localStorage.setItem("logOutUrl", logOutUrl)
          logout({ logoutParams: { returnTo: window.location.origin } })
          return
        }

        return Promise.reject(
          error.response?.data
            ? `${error.message}: ${error.response?.data.error || error.response?.data}`
            : `${error.message}: Something Went Wrong, Please Try Again`,
        )
      },
    )

    return () => {
      garconClient.interceptors.response.eject(resInterceptor)
    }
  }, [logout])
}
